import React, { Component } from 'react';
import Header from './Header';

//images
import break_img from '../resources/images/2-Break-The-Cycle-Cover.jpg'
import trans_img from '../resources/images/1-TransDefenseFund-Cover.jpg'
import image1 from '../resources/images/1-12things-print-title.jpg';
import image2 from '../resources/images/2-AskFirst.jpg';
import image3 from '../resources/images/3-Cassv-Reading-Group.jpg';
import image4 from '../resources/images/4-DIY-Guide-prevent-sexual-assault.jpg';
import image5 from '../resources/images/5-A-World-Without-Police.jpg';
import image6 from '../resources/images/6-ANTI-POLICE-BRUTALITY-1.jpg';
import image7 from '../resources/images/7-ANTI-POLICE-BRUTALITY-2.jpg';
import image8 from '../resources/images/8-AskingForIt.jpg';
import image9 from '../resources/images/9-CONSENT-WORKSHOP.jpg';
import image10 from '../resources/images/10-In-Our-Hands-Zine.jpg';
import image12 from '../resources/images/12-4649_CCA.jpg';
import image13 from '../resources/images/13-Learning-Good-Consent.jpg';
import image14 from '../resources/images/14-MyWorld-JeffOtt.jpg';
import image16 from '../resources/images/16-StrategiesForSurvivors.jpg';
import image17 from '../resources/images/17-RefusingToBeAMan.jpg';
import image18 from '../resources/images/18-AccountingForOurselves.jpg';
import image19 from '../resources/images/19-STIs.jpg';

//pdf&links
import break_pdf from '../resources/pdf/2-BREAK-THE-CYCLE.pdf'
import pdf1 from '../resources/pdf/1-12things-print.pdf';
import pdf2 from '../resources/pdf/2-ask_first.pdf';
import pdf3 from '../resources/pdf/3-cassv-reading-group-toolkit_shifting-from-carceral-to-tj-feminisms_final.pdf';
import pdf4 from '../resources/pdf/4-diy-guide-prevent-sexual-assault.pdf';
import pdf5 from '../resources/pdf/5-a-world-without-police-IMPOSED.pdf';
import pdf6 from '../resources/pdf/6-antipolicebrutalityflyer.pdf';
import pdf7 from '../resources/pdf/7-antipolicebrutalityflyer.pdf';
import pdf9 from '../resources/pdf/9-consent-workshop2.pdf';
import pdf10 from '../resources/pdf/10-in-our-hnads-1-imposed.pdf';
import pdf12 from '../resources/pdf/12-4649_CCASA-TSH-FINALJuly162019-WEB.pdf';
import pdf13 from '../resources/pdf/13-learning_good_consent.pdf';
import pdf16 from '../resources/pdf/16-strategiesforsurvivors.pdf';
import pdf18 from '../resources/pdf/18-accounting_for_ourselves.pdf';





const resources = [
  {
    img_path: break_img,
    link: break_pdf
  },
  {
    img_path: trans_img,
    link: 'https://transdefensefundla.org/pages/resources'
  },
  {
    img_path: image1,
    link: pdf1
  },
  {
    img_path: image2,
    link: pdf2
  },
  {
    img_path: image3,
    link: pdf3
  },
  {
    img_path: image4,
    link: pdf4
  },
  {
    img_path: image5,
    link: pdf5
  },
  {
    img_path: image6,
    link: pdf6
  },
  {
    img_path: image7,
    link: pdf7
  },
  {
    img_path: image8,
    link: 'https://www.hachettebookgroup.com/titles/kate-harding/asking-for-it/9780738217024/'
  },
  {
    img_path: image9,
    link: pdf9
  },
  {
    img_path: image10,
    link: pdf10
  },
  {
    img_path: image12,
    link: pdf12
  },
  {
    img_path: image13,
    link: pdf13
  },
  {
    img_path: image14,
    link: 'https://www.goodreads.com/book/show/904064.My_World'
  },
  {
    img_path: image16,
    link: pdf16
  },
  {
    img_path: image17,
    link: 'https://www.goodreads.com/book/show/433187.Refusing_to_be_a_Man'
  },
  {
    img_path: image18,
    link: pdf18
  },
  {
    img_path: image19,
    link: 'https://www.plannedparenthood.org/learn/stds-hiv-safer-sex/get-tested/how-do-i-talk-my-partner-about-std-testing'
  },
]

class Resources extends Component {

  render() {
    return (
      <div className="site-wrap">
        <Header page="Resources" />
        <div className="video-page-wrap">
          <div style={{ 'text-align': 'center' }}>
            <h2>COMMUNITY RESOURCES</h2>
            <p>HOW CAN WE BETTER RELATE TO EACH OTHER?</p>
          </div>
          <div className="resources-wrap">
            {
              resources.map(({ img_path, link }) => {
                const hyper = `${link}`
                return (
                  <div key={img_path} className="video-wrap resources" style={{ padding: '10px' }}>

                    <a href={hyper} target="_blank">
                      <img src={img_path} style={{ width: '200px', height: '200px'}}/>
                    </a>
                  </div>
                )
              })
            }
          </div>

        </div>
      </div>
    );
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/components/Resources.js